"use client";

import { usePathname } from "next/navigation";

import SpaceMain from "@/components/space/SpaceMain";

export default function SpaceLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname();

  if (pathname === "/space") return <>{children}</>;
  return <SpaceMain>{children}</SpaceMain>;
}
